<template>
    <div id="scanIn">
        <a-drawer :title="scanInAsnNo ?  fieldMap.tlScanIn.displayName + '('+ scanInAsnNo+')' : fieldMap.tlScanIn.displayName" @close="onClose" :visible="ScanInVis" width="95%">
            <!--头部search carton类型选择-->
      <a-row type="flex" justify="start" style="margin: 10px 0 0 0">
        <a-col :span="8" v-if="!isDirectScan">
          <div class="scanpackHeader">
            <div class="scanpackTitle" style="width: 210px">{{ fieldMap.tlRecId.displayName }}:</div>
            <a-input :placeholder="fieldMap.tlRecId.displayName " size="large" ref="scanInAsnNoRef" v-model="scanInAsnNo" @pressEnter="topAsnSearchEnter"/>
            <div class="scanpackTitle" style="width: 210px">{{ fieldMap.tlCartonId.displayName }}:</div>
            <a-input :placeholder="fieldMap.tlCartonId.displayName " size="large" ref="scanInCartonIdRef" v-model="scanInCartonId" @pressEnter="topAsnSearchEnter"/>
          </div>
        </a-col>
        <a-col>
          <a-popconfirm
              :title="$t('publicLang.Arecancel')"
              @confirm="cancenlGrClick"
              :okText="$t('publicLang.Yes')"
              :cancelText="$t('publicLang.No')"
          >
            <a-button size="small" type="primary" style="margin-left: 4px;" v-show="false">{{ $t('pubGicSet.CancelGR') }}</a-button>
          </a-popconfirm>
          <a-button size="small" type="primary" style="margin-left: 4px;" v-if="scanIntype == 'ASN_HEADER'" @click="newGr">{{ $t('pubGicSet.NewGR') }}</a-button>
        </a-col>
        <a-col class="ml4" style="display: flex;justify-content: center;align-items: center;margin-left: 20px;" v-if="scanTopCarTypeIsShow">
          <a-checkbox v-model="isDummyCarton">
            {{ fieldMap.tlIsCarton.displayName }}
          </a-checkbox>
          <a-checkbox v-model="isDirectScan" :disabled="isDirectScanDisable" @change="handleScanInDirectlySwitchChange">
            {{ fieldMap.tlScanInDirectly.displayName }}
          </a-checkbox>
        </a-col>
        <a-col>
          <a-button size="large" type="primary" style="margin-left: 4px;" @click="convertToReceive"  v-for="(item, index) in btnFunArr" :key="index"   v-if="item.code == 'Convert_To_Receive' && item.arr.length > 0" >{{ item.arr[0].name  }}</a-button>
        </a-col>
        <a-col class="ml4">
          <a-button size="large" type="primary" style="margin-left: 4px;"  v-for="(item, index) in btnFunArr" :key="index"   v-if="systemParam.SCAN_IN_CACHE == 'Y' && ! isDirectScan && item.code == 'Confirm' && item.arr.length > 0"   @click="confirmScanInList">{{ item.arr[0].name  }}</a-button>
        </a-col>
        <!--                  Detail-Print  -->
        <a-col v-for="item in btnFunArr" :key="item.uid" style="margin-top: 10px">

          <div v-if="item.code == 'Print'" style="margin-left: 4px;">
            <a-dropdown-button >
              {{ fieldMap.tlPrint.displayName  }}
              <a-menu slot="overlay" >
                <a-menu-item v-for="(tt,index) in item.arr" :key="index" @click="printByBtnConfig(tt)">{{tt.name}}</a-menu-item>
              </a-menu>
            </a-dropdown-button>
          </div>
        </a-col>
      </a-row>
      <a-divider style="margin: 10px 0"/>
      <div id="userHome">
        <div class="userDetail">
          <!--sacin 扫货-->
          <div class="userHome-left" :style="{ marginLeft: userLeft, width: userLeftWidth }">
            <div class="isShopple" @click="toggleCollapsed" v-if="false">
              <a-icon type="left" v-if="leftshow" />
              <a-icon type="right" v-else />
            </div>
            <div class="user-left-con">
              <div id="scanIntableClass" v-if="!isDirectScan">
                <vxe-table
                    border
                    resizable
                    :data.sync="sacanInTable"
                    class="mytable-style111"
                    :cell-class-name="cellClassName"
                    max-height="280"
                    show-footer
                    :footer-method="footerMethod"
                    :footer-cell-class-name="footerCellClassName"
                    size="mini">
                  <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                  </template>
                  <vxe-table-column field="sku" :title="fieldMap.tbSku.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="140"></vxe-table-column>
                  <vxe-table-column field="scanFieldValue" :title="fieldMap.tbUpc.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="140" class-name="scanFieldValue-class" :formatter="formatSpaceData"></vxe-table-column>
                  <vxe-table-column field="desc" :title="fieldMap.tbDescr.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="100"></vxe-table-column>
                  <vxe-table-column field="asnQty" :title="fieldMap.tbAsnQty.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="80"></vxe-table-column>
                  <vxe-table-column field="recQty" :title="fieldMap.tbScannedQty.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="80"> </vxe-table-column>
                  <vxe-table-column field="outstandingQty" :title="fieldMap.tbOutstandingQty.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="100"> </vxe-table-column>
                </vxe-table>
              </div>
              <a-divider dashed style="margin: 10px 0" v-if="!isDirectScan"/>
              <a-row>
                <a-form :form="scanForm">


                  <a-row v-if="systemParam.SCAN_IN_SCAN_CTNID == 'Y' ? true : systemParam.SCAN_IN_SCAN_CTNID == 'y' ? true : false">
                    <a-col class="ml4" :span="8" style="margin-left:0">
                      <a-form-item :label="fieldMap.siCartonId.displayName" :class="systemParam.SCAN_IN_SCAN_CTNID_REQ  == 'Y' ? 'genericFrom  request-form-item' : 'genericFrom'">
                        <a-input
                            style="width: 100%"
                            :placeholder="$t('pubGicSet.CartonIdNum')"
                            size="large"
                            :disabled="scanInlockSSCCChecked"
                            v-model.trim="cartonIdVal"
                            @pressEnter="scanCartonIdEnter"
                            ref="cartonIdNumRef"
                        />
                      </a-form-item>

                    </a-col>
                    <a-col class="ml10" :span="8">
                      <a-form-item   :label="fieldMap.siDeleteCartonId.displayName" class="genericFrom">
                        <a-checkbox :checked="scanCartonIdlockChecked" size="large"
                                    @change="scanCartonActionChange"></a-checkbox>
                      </a-form-item>
                    </a-col>
                  </a-row>



                  <a-row v-else>
                    <a-col class="ml4" :span="8" style="margin-left:0">
                      <a-form-item :label="fieldMap.siContainerId.displayName" :class="this.systemParam.SCAN_IN_CONTAINER_ID_REQUEST  == 'Y' ? 'genericFrom  request-form-item' : 'genericFrom'">
                        <a-input
                            style="width: 100%"
                            :placeholder="fieldMap.siContainerId.displayName"
                            size="large"
                            :disabled="scanInlockSSCCChecked"
                            v-model.trim="containerIdVal"
                            @pressEnter="scanContainerIdEnter"
                            ref="containerId"
                        />
                      </a-form-item>

                    </a-col>
                    <a-col class="ml10" :span="8">
                      <a-form-item v-if=" this.systemParam.SCAN_IN_EPC != 'Y' ? true :  false"  :label="fieldMap.siDeleteContainerId.displayName" class="genericFrom">
                        <a-checkbox :checked="scanContainerIdlockChecked" size="large"
                                    @change="scanContanierActionChange"></a-checkbox>
                      </a-form-item>
                    </a-col>



                    <a-col v-if="this.systemParam.SCAN_IN_EPC!=undefined && this.systemParam.SCAN_IN_EPC=='Y'" class="ml10" :span="8" style="margin-left: 14px">
                      <a-form-item   :label="fieldMap.siLockSscc.displayName">
                        <a-checkbox :checked="scanInlockSSCCChecked" @change="scanlockSSCCChangeEvnt"></a-checkbox>
                      </a-form-item>
                    </a-col>
                  </a-row>




                  <a-row>

                    <a-col v-if="epcVisible || this.systemParam.SCAN_IN_EPC!=undefined&&this.systemParam.SCAN_IN_EPC=='Y'|| this.systemParam.MBSHA_SCAN_IN_EPC == 'Y'" class="ml4" :span="8">
                      <a-form-item :label="fieldMap.siEpc.displayName"
                                   :class="epcVisible || this.systemParam.SCAN_IN_EPC  == 'Y' || (this.systemParam.MBSHA_SCAN_IN_EPC  == 'Y' && (orderType =='THRK' ||orderType =='HHRK' ))?'genericFrom  request-form-item' : 'genericFrom'">
                        <a-input
                            style="width: 100%;margin-left: -5px;"
                            :placeholder="fieldMap.siEpc.displayName"
                            size="large"
                            v-model.trim="epcVal"
                            @pressEnter="epcValEnter"
                            ref="epcRef"
                            :disabled="epcValDisabled"
                        />
                      </a-form-item>

                    </a-col>
                    <a-col class="ml10" :span="2" v-if="this.systemParam.SCAN_IN_EPC!=undefined&&this.systemParam.SCAN_IN_EPC=='Y'">
                      <a-form-item   :label="fieldMap.siGift.displayName">
                        <a-checkbox v-model="giftChecked" size="large" @change="giftCheckedChange"></a-checkbox>
                      </a-form-item>
                    </a-col>

                    <!--Tom 2024-12-03 special epc scan-->
                    <a-col class="ml10" :span="2"  v-if="this.systemParam.MBSHA_SCAN_IN_EPC!=undefined&&this.systemParam.MBSHA_SCAN_IN_EPC=='Y'">
                      <a-form-item>
                        <a-checkbox v-model="mbshaScanInEpcCheck" size="large" @change="mbshaScanInEpcCheckChange"
                                    style="margin-top: 25px"></a-checkbox>
                      </a-form-item>


                    </a-col>

                  </a-row>
                  <a-row>
                    <a-col :span="8">
                      <a-form-item :label="isDummyCarton ?  fieldMap.siDummyCartonId.displayName : fieldMap.siSku.displayName" class="genericFrom">
                        <a-input
                            ref="skuScanInRef"
                            style="width: 100%;"
                            :placeholder="isDummyCarton ?  fieldMap.siDummyCartonId.displayName : fieldMap.siSku.displayName"
                            size="large"
                            v-model="sacnInSkuVal"
                            @pressEnter="scanInSkuPressEnter"
                            :disabled="isLocaScanIn"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col class="ml4" :span="8">
                      <a-form-item :label="fieldMap.siQty.displayName" class="genericFrom">
                        <a-input-number id="inputNumber"
                                        v-model="sacnQtyVal" :min="1"
                                        :disabled="scanInlockChecked"
                                        style="width: 100%;"
                                        :placeholder="fieldMap.siQty.displayName"
                                        size="large"
                                        ref="scanInQtyNum"
                                        @pressEnter="qtyPressEnter"
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="8">
                      <a-form-item :label="fieldMap.siScanAction.displayName" class="genericFrom">
                        <a-radio-group @change="scanActionChange" v-model="scanActionVal" size="small">
                          <a-radio :value="1">{{ fieldMap.siAdd.displayName }}</a-radio>
                          <a-radio :value="2">{{ fieldMap.siRemove.displayName}}</a-radio>
                        </a-radio-group>
                      </a-form-item>
                    </a-col>
                    <!--                                        <a-col :span="5">-->
                    <!--                                            <a-form-item :label="$t('pubGicSet.StockStatus')" class="genericFrom">-->
                    <!--                                                <a-select v-model="cargoActionVal" @change="cargoActionChange"  style="width:100%" size="small" :placeholder="$t('publicLang.PleaseSelect')">-->
                    <!--                                                    <a-select-option value="1">Normal</a-select-option>-->
                    <!--                                                </a-select>-->
                    <!--                                            </a-form-item>-->
                    <!--                                        </a-col>-->
                    <a-col class="ml10" :span="8">
                      <a-form-item :label="fieldMap.siLockScanQty.displayName" class="genericFrom">
                        <a-checkbox :checked="scanInlockChecked"
                                    @change="scanlockChangeEvnt"></a-checkbox>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-form>
              </a-row>
              <a-row type="flex" justify="start" style="margin: 10px 0" v-if="!isDirectScan">
                <!--                                <a-col style="margin-left: 30px;">-->
                <!--                                    <p class="scanCodeTile">{{ $t('pubGicSet.RecQty') }}</p>-->
                <!--                                    <div  style="background: #009900;width: 160px;height: 160px;border-radius: 50%;text-align: center;">-->
                <!--                                        <div style="font-size: 70px;color: #fff;padding-top: 26px;position: relative;">-->
                <!--                                            <p>{{scaninRecOtyNum}}</p>-->
                <!--                                            <span style="font-size: 20px;color: #fff;position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);">({{scaninPercentageNum}})</span>-->
                <!--                                        </div>-->
                <!--                                    </div>-->
                <!--                                </a-col>-->
                <a-col style="margin-left: 30px;" >
                  <p class="scanCodeTile">{{ fieldMap.outstandingQty.displayName }}</p>
                  <div class="radiusback" style="background: #f36;">
                    <i>{{scaninOutstandingNum}}</i>
                  </div>
                </a-col>
                <a-col style="margin-left: 30px;"  v-if="this.systemParam.SCAN_IN_EPC == 'Y' ? false : true">
                  <p class="scanCodeTile">  {{ systemParam.SCAN_IN_SCAN_CTNID == 'Y' ? fieldMap.cartonIdQty.displayName : this.systemParam.SCAN_IN_SCAN_CTNID == 'y' ? fieldMap.cartonIdQty.displayName : fieldMap.containerIdQty.displayName  }}</p>
                  <div class="radiusback" style="background: #f3c17a;">
                    <i>{{containerIdQty}}</i>
                  </div>
                </a-col>
                <!--                                <a-col v-if=" this.systemParam.SCAN_IN_EPC == 'Y' ? true : false" style="margin-left: 10px;top: 120px;" >-->
                <!--                                        <div class="scanpackTitle" style="width: 60px">{{ $t('pubGicSet.SSCC1') }}:</div>-->
                <!--                                    <div class="scanpackHeader">-->
                <!--                                        <a-input size="large" ref="scanInSSCCRef" :disabled="scanInlockSSCCChecked" style="width: auto;margin-left: 30px" v-model="scanInSSCC" @pressEnter="ssccValEnter"/>-->
                <!--                                        <a-checkbox :checked="scanInlockSSCCChecked" style="margin-left: 20px" @change="scanlockSSCCChangeEvnt"></a-checkbox>-->
                <!--                                        <div class="scanpackTitle" style="width: 65px">{{ $t('pubGicSet.lockUpSSCC') }}</div>-->
                <!--                                    </div>-->
                <!--                                </a-col>-->
              </a-row>
              <a-row v-else>
                <a-row type="flex" justify="start" style="margin: 10px 0">
                  <a-col style="margin-left: 20px;">
                    <p class="scanCodeTile">{{ fieldMap.totalRecQty.displayName }}</p>
                    <div class="radiusback" style="background: #f36;">
                      <i>{{scanInDiredlyList.recQtyCount}}</i>
                    </div>
                  </a-col>
                </a-row>
                <a-row>
                  <vxe-table
                      border
                      resizable
                      :data.sync="scanInDiredlyList.directlyTable"
                      size="mini"
                      max-height="330"
                  >
                    <template v-slot:empty>
                      <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                    </template>
                    <vxe-table-column
                        min-width="250"
                        show-header-overflow="ellipsis" show-overflow="ellipsis"
                        field="locationCode"
                        :title="fieldMap.recLocation.displayName"
                    ></vxe-table-column>
                    <vxe-table-column
                        min-width="250"
                        show-header-overflow="ellipsis" show-overflow="ellipsis"
                        field="recQty"
                        :title=" fieldMap.recRecQty.displayName"
                    >
                    </vxe-table-column>
                  </vxe-table>
                </a-row>
              </a-row>
            </div>
          </div>
          <!--拉伸线-->
          <div
              class="center-line"
              @mousedown.prevent="dragStart"
              :style="{ left: proxyDomLeft }">
          </div>
          <!--scanIn location-->
          <div class="userHome-right" :style="{ width: userRightWidth }">
            <div class="user-right-con">
              <a-spin :spinning="locationSpin">
                <a-row>
                  <a-col>
                    <a-row type="flex" justify="start">
                      <a-col>{{ fieldMap.lcLocation.displayName}}:</a-col>
                      <a-col class="ml4"><a-input ref="locationRef" :placeholder=" fieldMap.lcLocation.displayName" size="small" @pressEnter="scaninLocationSearch" v-model="locationval"/></a-col>
                      <a-col class="ml4">
                        <a-button size="small" type="primary" style="margin-left: 4px;" @click="addNewLocation"  v-for="(item, index) in btnFunArr" :key="index"   v-if="item.code == 'Add_Location' && item.arr.length > 0">{{ item.arr[0].name  }}</a-button>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
                <a-row type="flex" justify="start" style="margin: 10px 0">
                  <a-col style="margin-left: 20px;">
                    <p class="scanCodeTile">{{  fieldMap.lcRecQty.displayName }}</p>
                    <div class="radiusback" style="background: #00ccff;">
                      <i>{{locationRecQty}}</i>
                    </div>
                  </a-col>
                  <a-col style="margin-left: 20px;">
                    <p class="scanCodeTile" v-if="!isDummyCarton">{{ fieldMap.lcNoOfSku.displayName  }}</p>
                    <p class="scanCodeTile" v-else>{{ fieldMap.lcNoOfCarton.displayName  }}</p>
                    <div class="radiusback" style="background: #3f9;">
                      <i>{{locationNoSku}}</i>
                    </div>
                  </a-col>
                </a-row>
              </a-spin>
              <a-row style="margin-right: 10px;">
                <vxe-table
                    border
                    resizable
                    :data.sync="scanLocationTable"
                    size="mini"
                    max-height="330"
                    class="mytable-style "
                    :cell-class-name="scanLocationTableClass"
                >
                  <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                  </template>
                  <vxe-table-column
                      width="150"
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                      field="sku"
                      :title="isDummyCarton ?  fieldMap.lcTbCarton.displayName : fieldMap.lcTbSku.displayName"
                  ></vxe-table-column>
                  <vxe-table-column
                      width="100"
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                      field="uom"
                      :title="fieldMap.lcTbUom.displayName">
                  </vxe-table-column>
                  <vxe-table-column
                      width="200"
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                      field="skuDesc"
                      :title="fieldMap.lcTbDescr.displayName">
                  </vxe-table-column>
                  <vxe-table-column
                      width="100"
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                      field="recQty"
                      :title="fieldMap.lcTbRecQty.displayName"
                  >
                  </vxe-table-column>
                </vxe-table>
              </a-row>

              <a-row v-if="(orderType=='THRK' || orderType =='HHRK')" style="margin-top: 20px;">
                <div style="margin: 0px 50px;">
                  <span style="font-size: 22px;color: red;">{{remarks}}</span>
                </div>
              </a-row>


            </div>
          </div>
        </div>
      </div>
    </a-drawer>
    <!--报错提示-->
    <a-modal
        :title="$t('pubGicSet.Error')"
        v-model="SkuExistVis"
        width="40%"
        @cancel="handleCancelSkuTishi"
        :footer="null"
    >
      <audio
          controls="controls"
          autoplay="autoplay"
          loop="loop"
          id="musicSKU"
          hidden>
        <source src="../../../assets/mm.mp3" type="audio/mpeg" />
      </audio>
      <a-alert type="error">
        <p slot="description" style="color: red;font-size: 30px;padding: 50px 0;text-align: center;line-height: 35px;">{{scanInTishiInfo}}</p>
      </a-alert>
    </a-modal>


    <audio
        controls="controls"
        ref="scanSuccessMusicRef"
        hidden>
      <source src="../../../assets/scan_success.mp3" type="audio/mpeg" />
    </audio>
    <scan-cus-sku-window ref="refScanCusSkuWindow"
                         @confirmCusSku="confirmCusSkuCallBack" @cusSkuWindowClose="cusSkuWindowCloseCallBack"></scan-cus-sku-window>
  </div>
</template>
<script>
import ajax from "../../../api/ajax";
import api from "../../../api/url";
import Fingerprint2 from "fingerprintjs2";
import { mapState } from "vuex";
import scanCusSkuWindow from "./scanCusSkuWindow.vue"
import axios from "axios";
import cookie from "../../../api/cookie";
export default{
  components: {
    scanCusSkuWindow
  },
  mounted() {
    this.show();
  },
  data(){
    return{
      fieldMap:{
        tlScanIn:{},
        tlRecId:{},
        tlCartonId:{},
        tlIsCarton:{},
        tlScanInDirectly:{},
        tlPrint:{},
        tbSku:{},
        tbUpc:{},
        tbDescr:{},
        tbAsnQty:{},
        tbScannedQty:{},
        tbOutstandingQty:{},
        siCartonId:{},
        siContainerId:{},
        siDeleteCartonId:{},
        siDeleteContainerId:{},
        siEpc:{},
        siGift:{},
        siSku:{},
        siDummyCartonId:{},
        siQty:{},
        siScanAction:{},
        siAdd:{},
        siRemove:{},
        siLockSscc:{},
        siLockScanQty:{},
        outstandingQty:{},
        cartonIdQty:{},
        containerIdQty:{},
        totalRecQty:{},
        recLocation:{},
        recRecQty:{},
        lcLocation:{},
        lcRecQty:{},
        lcNoOfSku:{},
        lcNoOfCarton:{},
        lcTbSku:{},
        lcTbCarton:{},
        lcTbUom:{},
        lcTbDescr:{},
        lcTbRecQty:{}
      },
//                左右拉伸样式
      proxyDomLeft: "", // 拖拽line
      userRightWidth: "", //  右宽
      userLeft: "", // 左left
      userLeftWidth: "", // 左宽
      leftshow: true,

      btnFunArr: [
        {code: 'Print',arr:[]},
        {code: 'Convert_To_Receive',arr:[]},
        {code: 'Confirm',arr:[]},
        {code: 'Add_Location',arr:[]},
      ],
      isDirectScan: null,
      isDummyCarton: null,
      isDirectScanDisable: false, // 扫完吗之后不能在选择
      scanInDiredlyList:{ // scanInDiredly 扫码之后返回的数据 recQty  table
        recQtyCount: 0,
        directlyTable: []
      },
      isLocaScanIn: true, // 每次创建location  才可以扫货
      scanTopCarTypeIsShow: true,


      scanFieldTitle: '', // left table 某个表头value
      SkuExistVis: false, // 是否打开报错提示

      scanLocationTable: [], // location table data
      ScanInVis: false, // 是否打开scanin
      sacanInTable: [],
      scanSkuInTable: [],
      scanForm: this.$form.createForm(this),
      locationval: '', // Staging
      locationRecQty: 0, // location 计算值
      locationNoSku: 0, // location 计算值
      locationSpin: false,
      sacnQtyVal: 1, // lock 数量
      epcVal:'',
      epcVisible:false,
      containerIdVal:'',
      cartonIdVal:'',
      containerIdVal_b:'',
      cartonIdVal_b:'',
      scanInlockChecked: true, // lock
      scanContainerIdlockChecked: false, // lock
      scanCartonIdlockChecked: false,
      sacnInSkuVal: '', // sku enter val
      scanInSkuValLocation:'',
      scanActionVal: 1,
      scanContainerIdActionVal: 1,
      cargoActionVal: '1',
      selectRow: {}, //scanIn table 所选中
      scanInOther: '', // scanIn 扫码后返回header table 当前数据
      scaninRecOtyNum: 0, // scanin 扫码后返回的值
      scaninOutstandingNum: 0, // scanin 扫码后返回的值
      scaninPercentageNum: 0, // scanin 扫码后返回的值
      containerIdQty:0,      //scanIn 当前的周转箱号
      scanInTishiInfo: 'not exist in the Scan In list', // 报错提示信息
      scanInAsnUid: '', // asn 转过的uid
      scanInAsnNo: '', // search  header No id
      scanInCartonId:'',// search  CartonId
      timesNum: 1, // 后台要求给
      scanInHeaderUid: '',
      scanIntype: '',
      scanInList:[],
      browserFingerprint:'',
      missText:'',
      giftChecked: false, // lock
      epcValDisabled:false,
      scanInlockSSCCChecked:false,
      mbshaScanInEpcCheck: false,
      orderType:'',
      lastScanSku:false,
      remarks: '',
      HUDF01: '',
    }
  },
  computed: {
    ...mapState(["systemParam"]),
    ...mapState(["projectCode"])
  },
  methods:{
    // replace Normal space with Non-Breaking space
    formatSpaceData({ cellValue }) {
      if (cellValue ==null || cellValue==undefined){
        return null;
      }
      return cellValue.replace(/ /g, '\u00A0');
    },
    handleScanInDirectlySwitchChange(checked){
      if (checked && (this.browserFingerprint == null || this.browserFingerprint == '')){
        let excludes = {};
        let options={excludes:excludes};
        let that = this;
        Fingerprint2.get(options,function (components) {
          // 参数
          const values = components.map(function (component) {
            return component.value;
          });
          //指纹
          const numrnur = Fingerprint2.x64hash128(values.join(''),31)
          that.browserFingerprint = numrnur.toString();
        });
      }
    },
    pubOutstandingSort(a,b){
      return b.outstandingQty-a.outstandingQty;
    },
    newGr(){
      this.locationval = '' // Staging
      this.scaninRecOtyNum =  0
      this.scaninOutstandingNum = 0
      this.scaninPercentageNum = 0
      this.containerIdQty = 0
      this.locationRecQty = 0
      this.locationNoSku = 0
      this.scanLocationTable = []
    },
    convertToReceive(){
      let params = {
        json:"{recId:'"+this.scanInAsnNo+"',cartonId:'"+this.scanInCartonId+"',browserFingerprint:'"+this.browserFingerprint+"'}"
      }
      let that = this;
      ajax.post(api.CONVERTTORECEIVE,params).then(res=>{
        if(res.code == 200){
          /*this.$message.success(res.msg, 3);
          this.scaninRecOtyNum =  0
          this.scaninOutstandingNum = 0
          this.scaninPercentageNum = 0
          this.containerIdQty = 0
          this.locationRecQty = 0
          this.locationNoSku = 0
          this.scanLocationTable = [];
          this.sacanInTable = [];
          this.topAsnSearchEnter();*/
          this.isLocaScanIn = false;
          this.sacnInSkuVal = '';
          let resMsg = res.msg;
          if(resMsg=="success"){
            resMsg =this.$t('cfs.operationSuccess');
          }
          this.$customMessage.success(resMsg,
              ()=>{
                that.scaninRecOtyNum =  0
                that.scaninOutstandingNum = 0
                that.scaninPercentageNum = 0
                that.containerIdQty = 0
                that.locationRecQty = 0
                that.locationNoSku = 0
                that.scanLocationTable = [];
                that.sacanInTable = [];
                that.scanInDiredlyList = { recQtyCount: 0, directlyTable: []};
                that.isDirectScanDisable = false;

                that.topAsnSearchEnter("convertToRec");
              });
        }else {
          this.$customMessage.error(res.msg,()=>{
            this.sacnInSkuVal = '';
            this.isLocaScanIn = false;
            this.$nextTick(()=>{
              this.$refs.skuScanInRef.focus();
            })
          });
        }
      })
    },
    sumPubFn(val) {
      let arr = this.sacanInTable;
      var sum = 0;
      for (let index in arr) {
        sum += arr[index][val];
      }
      return sum;
    },
    //            播放提示声
    audioPubFun() {
      let audio = document.getElementById("musicSKU");
      if (audio !== null) {
        if (audio.paused) {
          audio.play();
        } else {
          audio.pause();
        }
      }
    },
//            退出
    handleCancelSkuTishi(){
      this.audioPubFun();
      this.SkuExistVis = false;
    },
//            扫完当前数据把他放在最前
    fristTableRow(){
      for (let ii in this.sacanInTable) {
        if (this.sacanInTable[ii].uniqueKey == this.selectRow.uniqueKey) {
          this.sacanInTable.splice(ii, 1);
        }
      }
      this.sacanInTable.unshift(this.selectRow);
      let el = document.querySelector(
          "#scanIntableClass>.vxe-table>.vxe-table--main-wrapper"
      );
      el.scrollTop = 0;
    },
//            打开
    showIn(uid, type){
      this.isDirectScanDisable = false
      this.ScanInVis = true
      this.isLocaScanIn = true
      this.scanInUid = uid
      this.scanIntype = type
      this.scanInDiredlyList = { recQtyCount: 0, directlyTable: []}
      let SCAN_IN_DEFAULT_LOCATION = this.systemParam.SCAN_IN_DEFAULT_LOCATION==undefined?"N":this.systemParam.SCAN_IN_DEFAULT_LOCATION;

      ajax.get(api.SCANSHOW).then(res=>{
        this.scanTopCarTypeIsShow = res.data.isShow == 'true' ? true : false
      })

//                没有选择数据直接借来扫货时候
      if(uid == undefined && type == undefined){


        if ('Y'== SCAN_IN_DEFAULT_LOCATION){
          this.locationval = 'Staging';
          this.scaninLocationSearch();
        }else{
          this.$refs.locationRef.focus()
        }


        ajax.post(api.SCANINWAY).then(res=>{
          this.isDirectScan = res.data.isDirectScan == 'true' ? true : false
          this.isDummyCarton = res.data.isDummyCarton == 'true' ? true : false
        })
        return
      }
//                有uid 进来 一种是从ASN 那外一种 Scan In Management
      let params = {}
      if(this.scanIntype == "VASN"){
        params.asnUid = uid
      }else{
        params.grUid = uid
      }
      this.isDirectScan = null
      this.isDummyCarton = null
      ajax.get(api.SCANINIDGET,params).then(res=>{
        this.scanInAsnNo = res.data.recId
        this.scanInCartonId = res.data.cartonId;

        this.$nextTick(()=>{
          if ('Y'== SCAN_IN_DEFAULT_LOCATION){
            this.locationval = 'Staging';
            this.scaninLocationSearch();
          }else{
            this.$refs.locationRef.focus()
          }
        })
      })
      this.sacanInTable = []
      this.orderType = '';
      this.lastScanSku=false;
      this.init()
    },
//            清空数据
    clearScanIn(){
      this.scaninRecOtyNum =  0
      this.scaninOutstandingNum = 0
      this.scaninPercentageNum = 0
      this.containerIdQty = 0
      this.locationRecQty = 0
      this.locationNoSku = 0
      this.scanLocationTable = []
      this.locationval = ''
      this.sacnInSkuVal = ''
      this.containerIdVal = ''
      this.sacnQtyVal = 1
      this.scanActionVal = 1
      this.scanContainerIdActionVal=1
      this.scanInlockChecked = true
      this.scanInAsnNo = ''
      this.sacanInTable = [];
      this.scanInCartonId = ''
      this.containerIdVal = ''
      this.cartonIdVal = ''
      this.selectRow = {}
      this.epcVal = ''
      this.scanCartonIdlockChecked=false
    },
//            关闭
    onClose(){
      this.ScanInVis = false
      this.clearScanIn()
      this.scanInAsnNo = ''
      this.scanInCartonId = ''
      this.containerIdVal = ''
      this.cartonIdVal= ''
      this.timesNum = 1
      this.scanInHeaderUid = ''
      this.scanIntype = ''
      this.scanInUid = ''
      this.locationval = '' // Staging
      this.sacanInTable = [];
      this.epcVal = ''
      this.epcVisible = false;
    },
//            新增location
    addNewLocation(){
      this.locationval = ''
      this.isLocaScanIn = true
      this.$refs.locationRef.focus()
    },
//            search locaion
    scaninLocationSearch(){
      console.log("scaninLocationSearch")
      if(this.systemParam.SCAN_IN_CACHE == 'Y'){
        this.clearCache()
        // this.init("scan","")
        let params = {
          recId: this.scanInAsnNo,
          cartonId:this.scanInCartonId
        }
        if(this.scanIntype == 'GR_HEADER'){
          params.grUid = this.scanInUid
        }else{
          params.asnUid = this.scanInUid
        }
        ajax.get(api.SCANINTABLE,params).then(res=>{
          if(res.code == 200){
            this.isLocaScanIn = false;
            this.orderType = res.data.orderType;
            this.sacanInTable = res.data.table
            this.scanSkuInTable = res.data.table
            this.remarks = res.data.remarks
            this.HUDF01 = res.data.HUDF01
            if (res.data.isDirectScan  != 'true' ){
              this.scanTopCarTypeIsShow = false;
            }else {
              this.scanTopCarTypeIsShow = true;
            }
            this.isDirectScan = res.data.isDirectScan == 'true' ? true : false
            if(res.data.grHeaderUid != null){
              this.scanInHeaderUid = res.data.grHeaderUid
            }
            if(this.sacanInTable.length > 0){
              this.scanFieldTitle = this.sacanInTable[0].scanField
              this.scanInAsnUid = this.sacanInTable[0].asnUid
              this.scanInAsnNo = this.sacanInTable[0].recId
              this.sacanInTable.sort(this.pubOutstandingSort)

              let outstandingQtyNum = 0
              for (let tt in this.sacanInTable) {
                outstandingQtyNum = this.sacanInTable[tt].outstandingQty + outstandingQtyNum
                this.scaninOutstandingNum = outstandingQtyNum
                if(this.scanInCartonId!="" && this.selectRow.cartonId!= this.sacanInTable[tt].cartonId){
                  this.selectRow="";
                }
              }
              if(this.selectRow.uniqueKey){
                for (let ii in this.sacanInTable) {
                  if (this.sacanInTable[ii].uniqueKey == this.selectRow.uniqueKey) {
                    this.selectRow = this.sacanInTable[ii]
                    this.scaninRecOtyNum = this.sacanInTable[ii].recQty;
                    this.scaninPercentageNum =  Math.round((this.scaninRecOtyNum / this.sacanInTable[ii].asnQty) * 10000) / 100.0 + "%";
                  }
                }
              }
            }
          }
        })
      }
      this.locationSpin = true
      let params ={
        locationCode: this.locationval,
        recId:this.scanInAsnNo
      }
      if(this.scanIntype == 'GR_HEADER'){
        params.grHeaderUid = this.scanInUid
      }else{
        params.grHeaderUid = this.scanInHeaderUid
      }
      ajax.get(api.SCANLOCATION,params).then(res=>{
        if(res.code == 200){
          this.isLocaScanIn = false
          this.scanLocationTable = res.data.locationTab
          this.scanInHeaderUid = res.data.grHeaderUid
          let exitBrowserFingerprint = res.data.browserFingerprint
          if (exitBrowserFingerprint != null){
            this.browserFingerprint = exitBrowserFingerprint;
          }
          this.locationSumPub()

          if(this.scanInAsnNo == ''){
            this.$nextTick(()=>{
              this.$refs.scanInAsnNoRef.focus()
            })
          }else if(this.systemParam.SCAN_IN_EPC_BY_SKU === 'Y'){
            this.epcVal = "";
            this.sacnInSkuVal = "";
            this.epcVisible = false;
            this.$nextTick(()=>{
              this.$refs.skuScanInRef.focus()
            })
          }else if(this.systemParam.SCAN_IN_EPC == 'Y'||this.systemParam.MBSHA_SCAN_IN_EPC=='Y'){
            if(this.epcVal == '' || this.epcVal.length == 0){
              this.$nextTick(()=>{
                if(this.scanInlockSSCCChecked){
                  this.$refs.epcRef.focus()
                }else{
                  this.$refs.containerId.focus()
                }
              })
            }else{
              this.isLocaScanIn = false;
              this.$nextTick(()=>{
                this.$refs.skuScanInRef.select()
              })
            }
            return;
          }else if("Y" == this.systemParam.SCAN_IN_CONTAINER_ID_REQUEST){
            if(this.containerIdVal == '' || this.containerIdVal.length == 0){
              this.$nextTick(()=>{
                this.$refs.containerId.focus()
              })
            }else{
              this.isLocaScanIn = false;
              this.$nextTick(()=>{
                this.$refs.skuScanInRef.select()
              })
            }
            return;
          }else if ("Y" == this.systemParam.SCAN_IN_SCAN_CTNID){
            if("Y" == this.systemParam.SCAN_IN_SCAN_CTNID_REQ && (this.cartonIdVal == '' || this.cartonIdVal.length == 0)){
              this.$nextTick(()=>{
                this.$refs.cartonIdNumRef.focus()
              })
            }else{
              this.isLocaScanIn = false;
              this.$nextTick(()=>{
                this.$refs.skuScanInRef.select()
              })
            }
            return;
          }else{
            this.$nextTick(()=>{
              this.$refs.skuScanInRef.focus()
            })
          }
        }else{
          this.$customMessage.error(res.msg,()=>{
            this.$refs.locationRef.focus()
            this.$refs.locationRef.select()
            this.locationSpin = false
          });
        }
      })
    },
//            location 下面显示计算
    locationSumPub(){
      if(this.scanLocationTable.length>0) {
        let sum = 0
        for (let i in this.scanLocationTable) {
          sum = sum + this.scanLocationTable[i].recQty;
        }
        this.locationRecQty = sum
        this.locationNoSku = this.scanLocationTable.length
      }else{
        this.locationRecQty = 0
        this.locationNoSku = 0
        this.scanActionVal = 1
      }
      this.locationSpin = false
    },
//            sacnIn 数量enter 事件
    qtyPressEnter(){
      // if
      var regNumber = /^\+?[1-9][0-9]*$/;
      if(!regNumber.test(this.sacnQtyVal)){
                    this.$customMessage.warning( this.sacnQtyVal +' '+   this.$t('pubGicSet.QuantityTypeError'));
                    return;
                }
                this.$refs.skuScanInRef.focus()
                this.isLocaScanIn = true;
                this.scanInlockChecked = true;
                this.scanInSkuPressEnter()
            },
            //            表格样式
            cellClassName({ row }) {
                if (row === this.selectRow) {
                    return "col-orange";
                }
    },
    scanLocationTableClass({ row }) {
      if(row.sku ===this.scanInSkuValLocation){
        return "col-orange";
      }
    },
    scanActionChange(){
      // 如果拾remove
      if(this.scanActionVal == 2){
        this.scanInlockChecked = true
        this.sacnQtyVal = 1
      }
      this.$refs.skuScanInRef.focus()
    },
    scanContanierActionChange(){
      this.scanContainerIdlockChecked = !this.scanContainerIdlockChecked
    },
    scanCartonActionChange(){
      this.scanCartonIdlockChecked = !this.scanCartonIdlockChecked
    },
    cargoActionChange(){
      this.$refs.skuScanInRef.focus()
    },
    clearCache(){
      this.sacnInSkuVal = ''
      this.scaninRecOtyNum = 0
      this.scaninPercentageNum = 0
      // this.scaninOutstandingNum = 0
      this.containerIdQty = 0
      this.locationRecQty = 0
      this.locationNoSku = 0
      this.scanInList = []
      this.scanLocationTable = []
      this.epcVal = ''
    },
    //            top search
    topAsnSearchEnter(type){
      if(type=="convertToRec"){
        this.scanInCartonId='';
        this.scanInAsnNo='';
        this.scanInUid='';
      }
      this.init(1)
      this.containerIdVal = '';
      this.cartonIdVal = '';
      this.scanInHeaderUid = '';
      if(type=="convertToRec"){
        this.$nextTick(()=>{
          this.$refs.scanInCartonIdRef.focus();
        })
        return;
      }

      let containerIdRequest =  this.systemParam.SCAN_IN_CONTAINER_ID_REQUEST;

      if(this.scanInCartonId!=null && this.scanInCartonId!="") {
        this.containerIdVal=this.scanInCartonId;
        this.$nextTick(()=>{
          this.$refs.skuScanInRef.focus();
        })
        return;
      }

      if(this.locationval==null || this.locationval==""){
        this.$nextTick(()=>{
          this.$refs.locationRef.focus();
        })
      }else if("Y" == containerIdRequest &&  (this.containerIdVal==null || this.containerIdVal=="")){
        this.$nextTick(()=>{
          this.$refs.containerId.focus();
        })
      }else if("Y" == this.systemParam.SCAN_IN_EPC||this.systemParam.MBSHA_SCAN_IN_EPC=='Y'){
        this.$nextTick(()=>{
          if(this.scanInlockSSCCChecked){
            this.$refs.epcRef.focus()
          }else{
            this.$refs.containerId.focus()
          }
        })
      } else{
        this.$nextTick(()=>{
          this.$refs.skuScanInRef.focus();
        })
      }
      if(this.systemParam.SCAN_IN_EPC_BY_SKU === 'Y'){
        this.epcVal = '';
        this.epcVisible = false;
      }
    },
    refreshLocationTable(orderNo){
      let SCAN_IN_DEFAULT_LOCATION = this.systemParam.SCAN_IN_DEFAULT_LOCATION==undefined?"N":this.systemParam.SCAN_IN_DEFAULT_LOCATION;
      if ((this.locationval == ''  || this.locationval == null || this.locationval == undefined) &&'Y'== SCAN_IN_DEFAULT_LOCATION){
        this.locationval = 'Staging';
      }
      if ( this.locationval != null &&  this.locationval.length >0){
        this.locationSpin = true
        if ( orderNo == null || orderNo == '' || orderNo == undefined ){
          orderNo = this.scanInAsnNo;
        }

        let params ={
          locationCode: this.locationval,
          recId: orderNo
        }
        if(this.scanIntype == 'GR_HEADER'){
          params.grHeaderUid = this.scanInUid
        }else{
          params.grHeaderUid = this.scanInHeaderUid
        }
        ajax.get(api.SCANLOCATION,params).then(res=>{
          if(res.code == 200){
            this.isLocaScanIn = false
            this.scanLocationTable = res.data.locationTab
            this.scanInHeaderUid = res.data.grHeaderUid
            let exitBrowserFingerprint = res.data.browserFingerprint
            if (exitBrowserFingerprint != null){
              this.browserFingerprint = exitBrowserFingerprint;
            }
            this.locationSumPub()
          }
        })
      }
    },

//            获取table 数据 type == 1 是从topRecID 输入框search
    init(type,scanSku,isPlayScanSuccessMusic){
      let excludes = {};
      let options={excludes:excludes};
      let that = this;
      Fingerprint2.get(options,function (components) {
        // 参数
        const values = components.map(function (component) {
          return component.value;
        });
        //指纹
        const numrnur = Fingerprint2.x64hash128(values.join(''),31)
        if (that.browserFingerprint == null || that.browserFingerprint  == ''){
          that.browserFingerprint = numrnur.toString();
        }
      });

      let params = {
        recId: this.scanInAsnNo,
        cartonId:this.scanInCartonId
      }
      if(this.scanIntype == 'GR_HEADER'){
        params.grUid = this.scanInUid
      }else{
        params.asnUid = this.scanInUid
      }
      if(scanSku!="" || scanSku!=null){
        params.sku = scanSku
      }
      ajax.get(api.SCANINTABLE,params).then(res=>{
        if(res.code == 200){

          this.orderType = res.data.orderType;
          this.remarks = res.data.remarks
          this.HUDF01 = res.data.HUDF01
          if("Y" == this.systemParam.MBSHA_SCAN_IN_EPC){
            // Tom 2024-12-11 当ASN TYPE<> THRK ,HHRK时，防伪码扫描框自动勾选不扫描
            if(this.orderType != 'THRK' && this.orderType != 'HHRK') {
              this.mbshaScanInEpcCheck=true;
              this.mbshaScanInEpcCheckChange();
            }
          }


          if (1 == type){
            let  orderNo = this.scanInAsnNo;
            if ( (orderNo == null || orderNo == '' || orderNo == undefined ) && res.data != null && res.data.table != null && res.data.table.length > 0){
              orderNo = res.data.table[0].recId
            }
            this.refreshLocationTable(orderNo);
          }

          if(type=="scan"){
            this.isLocaScanIn = false;
            if( isPlayScanSuccessMusic){
              this.$refs.scanSuccessMusicRef.play();
            }

            if("Y" == this.systemParam.SCAN_IN_EPC){

              // Tom 2024-07-15 新增勾选框【赠品】，勾选后防伪码处扫描框即为灰色，光标自动跳到SKU扫描框
              if(this.giftChecked==true) {
                this.$nextTick(()=>{
                  this.$refs.skuScanInRef.focus();
                })
              } else {
                this.$nextTick(()=>{
                  if(this.scanInlockSSCCChecked){
                    this.$refs.epcRef.focus()
                  }else{
                    this.$refs.containerId.focus()
                  }
                })
              }
            }else if ("Y" == this.systemParam.SCAN_IN_SCAN_CTNID){
              if("Y" == this.systemParam.SCAN_IN_SCAN_CTNID_REQ && (this.cartonIdVal == '' || this.cartonIdVal.length == 0)){
                this.$nextTick(()=>{
                  this.$refs.cartonIdNumRef.focus()
                })
              }else{
                this.isLocaScanIn = false;
                this.$nextTick(()=>{
                  this.$refs.skuScanInRef.select()
                })
              }
            }else{
              this.$nextTick(()=>{
                this.$refs.skuScanInRef.focus();
              })
            }
          }else{
            if(res.data.needReplaceCard != undefined && res.data.needReplaceCard != null && res.data.needReplaceCard != "") {
              this.$alert(
                  //this.$t('publicLang.needToHangGooseDownGoldMedal'),
                  res.data.needReplaceCard,
                  {showClose:false,
                    confirmButtonText:this.$t('publicLang.Confirm')
                  }
              );
            }
            this.scanLocationTable=[];
          }
          this.sacanInTable = res.data.table
          if(scanSku=="" || scanSku==null){
            this.scanSkuInTable = res.data.table
          }
          this.isDirectScan = res.data.isDirectScan == 'true' ? true : false
          if(res.data.grHeaderUid != null){
            this.scanInHeaderUid = res.data.grHeaderUid
          }
          if(this.sacanInTable.length > 0){
            this.scanFieldTitle = this.sacanInTable[0].scanField
            this.scanInAsnUid = this.sacanInTable[0].asnUid
            this.scanInAsnNo = this.sacanInTable[0].recId
            this.sacanInTable.sort(this.pubOutstandingSort)

            let asnRemark = this.sacanInTable[0].REMARKS;
            if(null!=asnRemark && ''!=asnRemark){
              this.$alert(asnRemark,
                  {showClose:false,
                    confirmButtonText:this.$t('publicLang.Confirm')
                  }
              );
            }
            let MKKSHA_HUDF_06 = this.sacanInTable[0].HUDF_06;
            if(null!=MKKSHA_HUDF_06 && ''!=MKKSHA_HUDF_06){
              this.$alert(MKKSHA_HUDF_06,
                  {showClose:false,
                    confirmButtonText:this.$t('publicLang.Confirm')
                  }
              );
            }
//                            scaninOutstandingNum 总和
            let outstandingQtyNum = 0
            for (let tt in this.sacanInTable) {
              outstandingQtyNum = this.sacanInTable[tt].outstandingQty + outstandingQtyNum
              this.scaninOutstandingNum = outstandingQtyNum
              if(this.scanInCartonId!="" && this.selectRow.cartonId!= this.sacanInTable[tt].cartonId){
                this.selectRow="";
              }
            }
            if(this.selectRow.uniqueKey){
              for (let ii in this.sacanInTable) {
                if (this.sacanInTable[ii].uniqueKey == this.selectRow.uniqueKey) {
                  this.selectRow = this.sacanInTable[ii]
                  this.scaninRecOtyNum = this.sacanInTable[ii].recQty;
                  this.scaninPercentageNum =  Math.round((this.scaninRecOtyNum / this.sacanInTable[ii].asnQty) * 10000) / 100.0 + "%";
                }
              }
              //this.fristTableRow()
            }
          }
          if(this.systemParam.SCAN_IN_CACHE == 'Y'){
            this.clearCache()
          }
          if(this.lastScanSku == true) {

            if(this.systemParam.MBSHA_SCAN_IN_EPC == 'Y' && this.mbshaScanInEpcCheck == false && this.lastScanSku == true) {
              // Tom 2024-12-11 当防伪码为可扫描状态时，扫描防伪码扫描SKU后完成一件收货后，光标需跳回到防伪码处
              this.$nextTick(() => {
                this.$refs.epcRef.focus()
              })
              this.lastScanSku = false;
            }
          }
          if(this.systemParam.SCAN_IN_EPC_BY_SKU === 'Y'){
            this.$nextTick(() => {
              this.$refs.skuScanInRef.focus()
            })
          }
        }
      })
      this.missText = '';
    },
//            sku ajax 扫货
    scaninAjax(){

      if('CTR_R' == this.sacnInSkuVal){
        this.convertToReceive()
        return;
      }else if('CTR_C'  == this.sacnInSkuVal){
        this.confirmScanInList()
        this.isLocaScanIn = false;
        this.$nextTick(()=>{
          this.$refs.skuScanInRef.select()
        })
        return;
      }


      let SCANIN_SHOW = this.systemParam.SCANIN_SHOW == undefined ? 'N' : this.systemParam.SCANIN_SHOW;
      let params = {};
      params.grHeaderUid = this.scanInHeaderUid;
      params.location = this.locationval;
      params.scanAction = this.scanActionVal;
      params.scanQty = this.sacnQtyVal;
      params.sku = this.sacnInSkuVal;
      params.containerId = this.containerIdVal;
      params.cartonId = this.scanInCartonId;
      params.cartonIdNum = this.cartonIdVal;
      params.asnUid = this.scanInAsnUid;
      params.isDirectScan = this.isDirectScan;
      params.isDummyCarton = this.isDummyCarton;
      params.recId =  this.scanInAsnNo;
      params.browserFingerprint = this.browserFingerprint;
      params.uniqueKey=  null;
      if(this.scanIntype == 'GR_HEADER'){
        params.grUid = this.scanInUid
      }

      if(this.systemParam.SCAN_IN_EPC_BY_SKU === 'Y' || "Y" == this.systemParam.SCAN_IN_EPC){
        params.epc = this.epcVal;
      }

      if("Y" == this.systemParam.SCAN_IN_EPC||this.systemParam.MBSHA_SCAN_IN_EPC=='Y'){
        params.epc = this.epcVal;
      }

      if((! this.isDirectScan) && (! this.isDummyCarton) ){
        if(this.sacanInTable.length  == 0){
          this.isLocaScanIn = false;
          this.$customMessage.error('No data available',()=>{
            this.$refs.skuScanInRef.select()
          });
          return
        }

        let todsScanSkuLength = this.systemParam.SCAN_SKU_12_LETTER == undefined ? 'N' : this.systemParam.SCAN_SKU_12_LETTER;
        let i = {};
        if("Y" == SCANIN_SHOW){
          for (let t in this.scanSkuInTable) {
            if("Y"== todsScanSkuLength && this.sacnInSkuVal.length > 12){
              this.sacnInSkuVal = this.sacnInSkuVal.substring(0,12);
            }
            if (this.scanSkuInTable[t].uniqueKey == this.sacnInSkuVal || this.scanSkuInTable[t].sku == this.sacnInSkuVal || this.scanSkuInTable[t].scanFieldValue == this.sacnInSkuVal) {
              i = this.scanSkuInTable[t];
              break;
            } else {
              i = 0;
            }
          }
        }else{
          for (let t in this.sacanInTable) {
            if("Y"== todsScanSkuLength && this.sacnInSkuVal.length > 12){
              this.sacnInSkuVal = this.sacnInSkuVal.substring(0,12);
            }
            let upcArr = [];
            if(this.sacanInTable[t].upcs) {
              upcArr = this.sacanInTable[t].upcs.split(',');
            }

            if (this.sacanInTable[t].uniqueKey == this.sacnInSkuVal || this.sacanInTable[t].sku == this.sacnInSkuVal || this.sacanInTable[t].scanFieldValue == this.sacnInSkuVal || upcArr.includes(this.sacnInSkuVal)) {
              i = this.sacanInTable[t];
              break;
            } else {
              i = 0;
            }
          }
        }

        if(i == 0){
          this.audioPubFun();
          this.SkuExistVis = true;
          this.isLocaScanIn = false;
          this.$refs.skuScanInRef.select()
          this.scanInTishiInfo = this.$t('publicLang.notExistScanInList',{"0":this.sacnInSkuVal})
          return
        }
        this.selectRow = i;
        if("Y" == SCANIN_SHOW){
          this.scanSkuInTable.sort(this.pubOutstandingSort)
        }else{
          this.sacanInTable.sort(this.pubOutstandingSort)
        }
        params.uniqueKey = this.selectRow.uniqueKey
        params.sku=this.selectRow.sku
        params.upcs=this.selectRow.upcs

        // check sku
        if (params.scanAction == 1) {
          ajax.post(api.SACNINSKUCHECK, params).then(res=>{
            if(res.code == 200) {
              this.$alert(res.data, {showClose:false, confirmButtonText:this.$t('publicLang.Confirm')});
            }
          })
        }

      }

      // if(this.systemParam.SCAN_IN_CACHE != 'Y'){
      //     if(this.scanActionVal == 2){
      //         if(this.scanInDiredlyList.recQtyCount == 0){
      //             this.scanActionVal = 1
      //             return
      //         }
      //     }
      // }

      if(this.systemParam.SCAN_IN_EPC_BY_SKU === 'Y'){
        if(!this.epcVisible){
          for (let t in this.scanSkuInTable) {
            if ((this.scanSkuInTable[t].sku == this.sacnInSkuVal || this.scanSkuInTable[t].scanFieldValue == this.sacnInSkuVal)
                && (this.scanSkuInTable[t].isSnControl === 'true' || this.scanSkuInTable[t].isSnControl === 'Y')) {
              this.epcVisible = true;
              this.$nextTick(() => {
                this.epcVal = '';
                if (this.$refs.epcRef) {
                  this.$refs.epcRef.focus();
                }
              })
              return;
            }
          }
        }
      }

      if(this.systemParam.SCAN_IN_CACHE == 'Y'){//缓存扫描 Liyy 2022-12-7
        if( this.locationval == null  || this.locationval == ''  ){
          this.audioPubFun();
          this.SkuExistVis = true
          this.scanInTishiInfo  = this.$t('publicLang.locationIsNull')
          return
        }
        if(this.sacanInTable.length > 0){
          this.isLocaScanIn = false;
          if(this.scanActionVal == 2){//删除
            this.scanActionVal = 1

            let containerIdList = '';
            let containerIdFlag = true;


            let cartonIdNumList = '';
            let cartonIdNumFlag = true;

            for (let ss in this.scanInList) {

              let upcArr = [];
              if(this.scanInList[ss].upcs) {
                upcArr = this.scanInList[ss].upcs.split(',');
              }

              if(this.scanInList[ss].sku == this.sacnInSkuVal || upcArr.includes(this.sacnInSkuVal)){
                if (this.systemParam.SCAN_IN_SCAN_CTNID != null && this.systemParam.SCAN_IN_SCAN_CTNID.toLowerCase() ==  'y'){
                  if(this.scanInList[ss].cartonIdNum == this.cartonIdVal){
                    if(this.scanInList[ss].recQty- this.sacnQtyVal < 0 ){
                      this.audioPubFun();
                      this.SkuExistVis = true
                      this.scanInTishiInfo  = this.$t('publicLang.overRemoveMsg',{"0":this.sacnInSkuVal})
                      this.sacnInSkuVal = ''
                      return
                    }
                    cartonIdNumFlag = false;
                  }else{
                    if(cartonIdNumList.length > 0){
                      cartonIdNumList += ','
                    }
                    cartonIdNumList += this.scanInList[ss].cartonIdNum
                  }
                }else {
                  if(this.scanInList[ss].containerId == this.containerIdVal){
                    if(this.scanInList[ss].recQty- this.sacnQtyVal < 0 ){
                      this.audioPubFun();
                      this.SkuExistVis = true
                      this.scanInTishiInfo  = this.$t('publicLang.overRemoveMsg',{"0":this.sacnInSkuVal})
                      this.sacnInSkuVal = ''
                      return
                    }
                    containerIdFlag = false;
                  }else{
                    if(containerIdList.length > 0){
                      containerIdList += ','
                    }
                    containerIdList += this.scanInList[ss].containerId
                  }
                }
              }
            }

            if (this.systemParam.SCAN_IN_SCAN_CTNID != null && this.systemParam.SCAN_IN_SCAN_CTNID.toLowerCase() ==  'y' ){
              if (cartonIdNumFlag){
                this.audioPubFun();
                this.SkuExistVis = true
                this.scanInTishiInfo  = this.$t('publicLang.CartonIdNumNotExists')
                this.sacnInSkuVal = ''
                return
              }
            }else {
              if(containerIdFlag){
                this.audioPubFun();
                this.SkuExistVis = true
                this.scanInTishiInfo  = this.$t('publicLang.containerIdNotExists')
                this.sacnInSkuVal = ''
                return
              }
            }

            for (let tt in this.sacanInTable) {

              let upcArr = [];
              if(this.sacanInTable[tt].upcs) {
                upcArr = this.sacanInTable[tt].upcs.split(',');
              }

              if(this.sacanInTable[tt].sku == this.sacnInSkuVal || upcArr.includes(this.sacnInSkuVal)){
                if(this.sacanInTable[tt].recQty - this.sacnQtyVal < 0) {
                  this.audioPubFun();
                  this.SkuExistVis = true
                  this.scanInTishiInfo  = this.$t('publicLang.overRemoveMsg',{"0":this.sacnInSkuVal})

                  this.sacnInSkuVal = ''
                  return
                }
                if(this.scanInList.length == 0){
                  this.sacnInSkuVal = ''
                  return
                }

                this.containerIdQty -= this.sacnQtyVal
                this.scaninOutstandingNum = this.scaninOutstandingNum + this.sacnQtyVal;
                this.locationRecQty = this.locationRecQty - this.sacnQtyVal < 0 ? 0 : this.locationRecQty - this.sacnQtyVal;
                this.sacanInTable[tt].recQty = this.sacanInTable[tt].recQty - this.sacnQtyVal
                this.sacanInTable[tt].outstandingQty = this.sacanInTable[tt].asnQty - this.sacanInTable[tt].recQty
                this.scaninRecOtyNum = this.scaninRecOtyNum - this.sacnQtyVal ;
                this.scaninPercentageNum = Math.round((this.sacanInTable[tt].recQty / this.sacanInTable[tt].asnQty) * 10000) / 100.0 + "%";
                // this.locationNoSku = this.sacanInTable[tt].recQty;

                this.$refs.scanSuccessMusicRef.play();


                if(this.scanLocationTable.length > 0){
                  for (let dd in this.scanLocationTable) {
                    let upcArr1 = [];
                    if(this.scanLocationTable[dd].upcs) {
                      upcArr1 = this.scanLocationTable[dd].upcs.split(',');
                    }
                    if(this.scanLocationTable[dd].sku == this.sacnInSkuVal || upcArr1.includes(this.sacnInSkuVal)){
                      this.scanLocationTable[dd].recQty = this.scanLocationTable[dd].recQty - this.sacnQtyVal
                      for (let ss in this.scanInList) {
                        let upcArr2 = [];
                        if(this.scanInList[ss].upcs) {
                          upcArr2 = this.scanInList[ss].upcs.split(',');
                        }
                        if (this.scanInList[ss].sku == this.sacnInSkuVal || upcArr2.includes(this.sacnInSkuVal)){
                          if (this.systemParam.SCAN_IN_SCAN_CTNID != null && this.systemParam.SCAN_IN_SCAN_CTNID.toLowerCase() ==  'y'){
                            if (this.scanInList[ss].cartonIdNum == this.cartonIdVal){
                              this.scanInList[ss].scanQty = this.scanInList[ss].scanQty - this.sacnQtyVal
                              if(this.scanInList[ss].scanQty == 0){
                                this.scanInList.splice(ss,1);
                              }
                              break
                            }
                          }else {
                            if (this.scanInList[ss].containerId == this.containerIdVal){
                              this.scanInList[ss].scanQty = this.scanInList[ss].scanQty - this.sacnQtyVal
                              if(this.scanInList[ss].scanQty == 0){
                                this.scanInList.splice(ss,1);
                              }
                              break
                            }

                          }
                        }
                      }
                      if(this.scanLocationTable[dd].recQty == 0){
                        this.scanLocationTable.splice(dd,1);
                      }
                      break
                    }
                  }
                }

                this.locationNoSku = this.scanLocationTable.length;
                break;
              }
            }
          }else{//扫入
            for (let tt in this.sacanInTable) {

              let upcArr = [];
              if(this.sacanInTable[tt].upcs) {
                upcArr = this.sacanInTable[tt].upcs.split(',');
              }

              if(this.sacanInTable[tt].sku == this.sacnInSkuVal || upcArr.includes(this.sacnInSkuVal)){
                if(this.sacanInTable[tt].recQty + this.sacnQtyVal > this.sacanInTable[tt].asnQty) {
                  this.audioPubFun();
                  this.SkuExistVis = true
                  this.scanInTishiInfo  = this.$t('publicLang.overScanMsg',{"0":this.sacnInSkuVal})
                  this.sacnInSkuVal = ''

                  if(this.systemParam.SCAN_IN_EPC_BY_SKU === 'Y'){
                    this.$nextTick(() => {
                      this.epcVal = '';
                      this.epcVisible = false;
                      if (this.$refs.skuScanInRef) {
                        this.$refs.skuScanInRef.focus();
                      }
                    })
                  }

                  return
                }
                // if (! this.systemParam.SCAN_IN_SCAN_CTNID.toLowerCase() ==  'y' ){
                //     this.containerIdQty = 0
                // }
                for (let gg in this.scanInList) {
                  if (this.systemParam.SCAN_IN_SCAN_CTNID != null &&  this.systemParam.SCAN_IN_SCAN_CTNID.toLowerCase() ==  'y' ){
                    // if (this.scanInList[gg].cartonIdNum == this.cartonIdVal){
                    //     this.containerIdQty += this.scanInList[gg].scanQty;
                    // }
                  }else {
                    // if(this.scanInList[gg].containerId == this.containerIdVal){
                    //     this.containerIdQty += this.scanInList[gg].scanQty;
                    // }
                  }
                }

                this.containerIdQty += this.sacnQtyVal
                this.scaninOutstandingNum = this.scaninOutstandingNum - this.sacnQtyVal;
                this.locationRecQty = this.locationRecQty + this.sacnQtyVal;
                this.sacanInTable[tt].recQty = this.sacanInTable[tt].recQty + this.sacnQtyVal
                this.sacanInTable[tt].outstandingQty = this.sacanInTable[tt].asnQty - this.sacanInTable[tt].recQty
                this.scaninRecOtyNum = this.sacanInTable[tt].recQty;
                this.scaninPercentageNum = Math.round((this.sacanInTable[tt].recQty / this.sacanInTable[tt].asnQty) * 10000) / 100.0 + "%";




                let detail = {
                  sku: this.sacanInTable[tt].sku,
                  upcs: this.sacanInTable[tt].upcs,
                  uom: 'EA',
                  skuDesc: this.sacanInTable[tt].desc,
                  recQty: this.systemParam.SCAN_IN_CACHE == 'Y' ? this.sacnQtyVal :  this.sacanInTable[tt].recQty,
                }
                if(this.scanLocationTable.length > 0){
                  let add = true;//是否新增数据
                  for (let dd in this.scanLocationTable) {
                    if(this.scanLocationTable[dd].sku == this.sacanInTable[tt].sku){

                      this.scanLocationTable[dd].recQty = this.scanLocationTable[dd].recQty + this.sacnQtyVal

                      if(this.scanInList.length > 0){
                        let addFlag = true; // true 新增
                        for (let cc in this.scanInList) {
                          if(this.scanInList[cc].sku == this.sacanInTable[tt].sku ){
                            if (this.systemParam.SCAN_IN_SCAN_CTNID != null && this.systemParam.SCAN_IN_SCAN_CTNID.toLowerCase() =='y'){
                              if (this.scanInList[cc].cartonIdNum == this.cartonIdVal){
                                this.scanInList[cc].scanQty = this.scanInList[cc].scanQty + this.sacnQtyVal
                                addFlag = false;
                                break
                              }
                            }else {
                              if (this.scanInList[cc].containerId == this.containerIdVal){
                                this.scanInList[cc].scanQty = this.scanInList[cc].scanQty + this.sacnQtyVal
                                addFlag = false;
                                break
                              }
                            }
                          }
                        }
                        if( addFlag ){
                          this.scanInList.push(params)
                        }

                      }else{
                        this.scanInList.push(params)
                      }
                      add = false
                      break
                    }
                  }
                  if(add){
                    this.scanInList.push(params)
                    this.scanLocationTable.push(detail)
                  }
                }else{
                  this.scanInList.push(params)
                  this.scanLocationTable.push(detail)
                }
                this.locationNoSku = this.scanLocationTable.length;
                break;
              }
            }
          }
          this.sacnInSkuVal = ''
          this.$refs.skuScanInRef.focus()
          this.$refs.scanSuccessMusicRef.play();

          if(this.systemParam.SCAN_IN_EPC_BY_SKU === 'Y'){
            this.$nextTick(() => {
              this.epcVal = '';
              this.epcVisible = false;
              if (this.$refs.skuScanInRef) {
                this.$refs.skuScanInRef.focus();
              }
            })
          }

        }
      }else{
        params.missText = this.missText;
        ajax.post(api.SACNINSKUSAOMA,params).then(res=>{
          if(res.code == 200){
            // if(this.isDirectScan){
            ajax.get(api.SCANDIRECLYTABLE,{grHeaderUid: res.data.grHeaderUid}).then(res=>{
              this.scanInDiredlyList = res.data
            })
            // }


            if(this.isDummyCarton){
              this.selectRow.uniqueKey = res.data.other.uniqueKey
            }
            this.isDirectScanDisable = true
            this.scanInHeaderUid = res.data.grHeaderUid
            this.scanInAsnNo = res.data.recId
            this.scanLocationTable = res.data.locationTable
            this.scanInSkuValLocation = this.sacnInSkuVal;
            this.sacnInSkuVal = ""
            this.epcVal = ""

            if(params.scanAction == 2){
              this.containerIdQty = parseInt(this.containerIdQty) - parseInt(params.scanQty) < 0 ? 0 : parseInt(this.containerIdQty) - parseInt(params.scanQty)
            }else{
              this.containerIdQty = parseInt(this.containerIdQty) + parseInt(params.scanQty)
            }
            this.locationSumPub()
            if("Y"==SCANIN_SHOW){
              this.init("scan",this.scanInSkuValLocation,true)
            }else{
              this.init("scan","",true)
            }
            this.scanActionVal = 1;
            this.lastScanSku = res.data.lastScanSku !=undefined && res.data.lastScanSku!=null?res.data.lastScanSku:false;

          }else{
            this.sacnInSkuVal = "";
            this.scanInTishiInfo = res.msg
            this.SkuExistVis = true
            this.audioPubFun()
            this.isLocaScanIn = false;
          }
          if(this.systemParam.SCAN_IN_EPC_BY_SKU === 'Y'){
            this.$nextTick(() => {
              this.epcVal = '';
              this.epcVisible = false;
              if (this.$refs.skuScanInRef) {
                this.$refs.skuScanInRef.focus();
              }
            })
          }
        })

        // Tom 20240611 MKKSHA 缺失值清空
        this.missText = '';




      }
    },

    confirmScanInList(){//点击Confirm提交
      if(this.scanInList.length == 0){
        this.$customMessage.warning('No data available');
        this.sacnInSkuVal = '';
        return
      }
      ajax.post(api.SCANINLISTSKU,this.scanInList).then(res=>{
        if(res.code == 200){
          // this.$customMessage.success('Success submit',()=>{
          this.$message.success(res.msg)
          this.clearCache()
          this.refreshLocationTable();
          // })
        }else{
          this.scanInTishiInfo = res.msg
          this.SkuExistVis = true
          this.audioPubFun()
          this.isLocaScanIn = false;
        }
      })
    },
    epcValEnter(){
      if(""==this.epcVal || this.epcVal.length==0){
        this.$customMessage.error(this.$t('pubGicSet.EPCIsEmpty'));
        return;
      }

      if(this.systemParam.SCAN_IN_EPC_BY_SKU === 'Y') {
        this.scaninAjax();
        return;
      }

      if(this.systemParam.SCAN_IN_EPC=='Y' &&this.projectCode=='MKKSHA' && this.HUDF01!='C6'){
        if(this.epcVal.length!=24){
          let that = this;
          this.$customMessage.error(this.$t('pubGicSet.EPCFormatError'),function () {
            that.epcVal='';
            that.$refs.epcRef.focus();
          });
          return;
        }
      }
      this.isLocaScanIn = false;
      this.$nextTick(() => {
        this.$refs.skuScanInRef.focus()
      })
    },
    ssccValEnter(){
      if(""==this.scanInSSCC || this.scanInSSCC.length==0){
        this.$customMessage.error(this.$t('pubGicSet.SSCCIsEmpty'));
        return;
      }
      this.isLocaScanIn = false;
      this.$nextTick(() => {
        if(this.scanInlockSSCCChecked){
          this.$refs.epcRef.focus()
        }else{
          this.$refs.containerId.focus()
        }
      })
    },
    validateStringWithRegex(str, regexPattern) {
      let regex;
      try {
        regex = new RegExp(regexPattern);
      } catch (e) {
        return {
          success: false,
          msg: this.$t('pubGicSet.CartonIdNumRegExp')
        };
      }

      // 2. 校验字符串是否符合该正则表达式
      const isValid = regex.test(str);
      return {
        success: isValid,
        msg: isValid ? null :  this.$t('pubGicSet.CartonIdNumFormatError',{"0":this.cartonIdVal})
      };
    },
    scanCartonIdEnter(){
      if(this.cartonIdVal_b != this.cartonIdVal){
        this.containerIdQty = 0;
      }
      let scanInCtnidRegex =  this.systemParam.SCAN_IN_CTNID_REGEX;
      if( this.cartonIdVal != null && this.cartonIdVal.length > 0 && scanInCtnidRegex != undefined && scanInCtnidRegex != null &&  (scanInCtnidRegex.length > 0)){
        let res = this.validateStringWithRegex(this.cartonIdVal,scanInCtnidRegex);
        if (! res.success){
          this.$customMessage.error(res.msg);
          return;
        }
      }

      if(this.scanCartonIdlockChecked) {
        let isDel = false;
        if (this.systemParam.SCAN_IN_CACHE == 'Y' && this.scanInList.length > 0) {

          for (let ss = this.scanInList.length - 1; ss >= 0; ss--) {
            if (this.scanInList[ss].cartonIdNum == this.cartonIdVal) {
              let unScanQty = this.scanInList[ss].scanQty;
              for (let tt in this.sacanInTable) {
                if (this.sacanInTable[tt].sku == this.scanInList[ss].sku) {

                  this.$set(this.sacanInTable, tt, {
                    ...this.sacanInTable[tt],
                    outstandingQty: this.sacanInTable[tt].outstandingQty + unScanQty,
                    recQty: this.sacanInTable[tt].recQty - unScanQty
                  });
                  this.scaninPercentageNum = Math.round((this.sacanInTable[tt].recQty / this.sacanInTable[tt].asnQty) * 10000) / 100.0 + "%";
                }
              }
              let skuNum = this.scanLocationTable.length;
              for (let dd in this.scanLocationTable) {
                if (this.scanLocationTable[dd].sku == this.scanInList[ss].sku) {
                  this.scanLocationTable[dd].recQty = this.scanLocationTable[dd].recQty - unScanQty
                  if (this.scanLocationTable[dd].recQty == 0) {
                    this.scanLocationTable.splice(dd, 1);
                    skuNum -= 1;
                  }
                }
              }
              isDel = true;
              this.scanInList.splice(ss, 1);
              this.containerIdQty = 0
              this.scaninOutstandingNum = this.scaninOutstandingNum + unScanQty;
              this.locationRecQty = this.locationRecQty - unScanQty;
              this.locationNoSku = skuNum;
            }
          }
        }



        let params = {
          grHeaderUid: this.scanInHeaderUid,
          cartonIdNum:this.cartonIdVal,
          cartonId:this.scanInCartonId,
          asnUid: this.scanInAsnUid,
          recId: this.scanInAsnNo
        }
        let that = this;
        ajax.post(api.ScanDeleteContailerId,params).then(res=>{
          if(res.code == 200){
            //this.$message.success(this.$t('cfs.operationSuccess'))
            this.$customMessage.success(this.$t('cfs.operationSuccess'),()=>{
              that.scaninRecOtyNum =  0
              that.scaninOutstandingNum = 0
              that.scaninPercentageNum = 0
              that.containerIdQty = 0
              that.locationRecQty = 0
              that.locationNoSku = 0
              that.scanLocationTable = [];
              that.sacanInTable = [];
              that.topAsnSearchEnter();
            });


          }else{
            if (! isDel){
              this.$customMessage.error(res.msg)
            }
          }
        })
        this.cartonIdVal="";
        this.scanContanierActionChange();
      }else{
        let params = {
          grHeaderUid: this.scanInHeaderUid,
          cartonIdNum:this.cartonIdVal,
          cartonId:this.scanInCartonId,
          asnUid: this.scanInAsnUid,
          recId: this.scanInAsnNo,
          location: this.locationval
        }
        ajax.post(api.CountScanQtyByContainerId,params).then(res=>{
          if(res.code == 200){
            this.containerIdQty = res.data
            if ( this.scanInList != null && this.scanInList.length>0){
              for (let ss = this.scanInList.length - 1; ss >= 0; ss--) {
                if (this.scanInList[ss].cartonIdNum == this.cartonIdVal) {
                  let scanQty = this.scanInList[ss].scanQty;
                  this.containerIdQty += scanQty;
                }
              }
            }
          }else {
            this.cartonIdVal="";
            this.cartonIdVal_b="";
            this.scanInTishiInfo = res.msg;
            this.SkuExistVis = true;
            this.$refs.cartonIdNumRef.focus()
            this.audioPubFun();
            return
          }
        })

        this.cartonIdVal_b=this.cartonIdVal
        this.isLocaScanIn = false;
        this.$nextTick(() => {
          if(this.systemParam.SCAN_IN_EPC!=undefined&&this.systemParam.SCAN_IN_EPC=='Y'&&!this.giftChecked){
            this.$refs.epcRef.focus()
          }else if(this.systemParam.MBSHA_SCAN_IN_EPC!=undefined&&this.systemParam.MBSHA_SCAN_IN_EPC=='Y'&&!this.mbshaScanInEpcCheck){
            this.$refs.epcRef.focus()
          } else{
            this.$refs.skuScanInRef.focus()
          }
        })
      }
    },
    scanContainerIdEnter(){
      if(this.containerIdVal_b!=this.containerIdVal){
        this.containerIdQty = 0;
      }

      let containerIdRequest =  this.systemParam.SCAN_IN_CONTAINER_ID_REQUEST;
      if("Y" == containerIdRequest  &&  (""==this.containerIdVal || this.containerIdVal.length==0)){
        this.$customMessage.error(this.$t('pubGicSet.ContainerIdIsEmpty'));
        return;
      }
      if(this.scanContainerIdlockChecked){

        let isDel = false;
        if (this.systemParam.SCAN_IN_CACHE == 'Y' && this.scanInList.length > 0) {
          for (let ss = this.scanInList.length - 1; ss >= 0; ss--) {
            if (this.scanInList[ss].containerId == this.containerIdVal) {
              let unScanQty = this.scanInList[ss].scanQty;
              for (let tt in this.sacanInTable) {
                if (this.sacanInTable[tt].sku == this.scanInList[ss].sku) {
                  this.$set(this.sacanInTable, tt, {
                    ...this.sacanInTable[tt],
                    outstandingQty: this.sacanInTable[tt].outstandingQty + unScanQty,
                    recQty: this.sacanInTable[tt].recQty - unScanQty
                  });
                  this.scaninPercentageNum = Math.round((this.sacanInTable[tt].recQty / this.sacanInTable[tt].asnQty) * 10000) / 100.0 + "%";
                }
              }
              let skuNum = this.scanLocationTable.length;
              for (let dd in this.scanLocationTable) {
                if (this.scanLocationTable[dd].sku == this.scanInList[ss].sku) {
                  this.scanLocationTable[dd].recQty = this.scanLocationTable[dd].recQty - unScanQty
                  if (this.scanLocationTable[dd].recQty == 0) {
                    this.scanLocationTable.splice(dd, 1);
                    skuNum -= 1;
                  }
                }
              }
              isDel = true;
              this.scanInList.splice(ss, 1);
              this.containerIdQty = 0
              this.scaninOutstandingNum = this.scaninOutstandingNum + unScanQty;
              this.locationRecQty = this.locationRecQty - unScanQty;
              this.locationNoSku = skuNum;
            }
          }
        }

        let params = {
          grHeaderUid: this.scanInHeaderUid,
          containerId:this.containerIdVal,
          cartonId:this.scanInCartonId,
          asnUid: this.scanInAsnUid,
          recId: this.scanInAsnNo
        }
        let that = this;
        ajax.post(api.ScanDeleteContailerId,params).then(res=>{
          if(res.code == 200){
            //this.$message.success(this.$t('cfs.operationSuccess'))
            this.$customMessage.success(this.$t('cfs.operationSuccess'),()=>{
              that.scaninRecOtyNum =  0
              that.scaninOutstandingNum = 0
              that.scaninPercentageNum = 0
              that.containerIdQty = 0
              that.locationRecQty = 0
              that.locationNoSku = 0
              that.scanLocationTable = [];
              that.sacanInTable = [];
              that.topAsnSearchEnter();
            })

          }else{
            if (! isDel) {
              this.$customMessage.error(this.$t('publicLang.containerIdNotExists'))
            }
          }
        })
        this.containerIdVal="";
        this.scanContanierActionChange();
      }else{
        let params = {
          grHeaderUid: this.scanInHeaderUid,
          containerId:this.containerIdVal,
          cartonId:this.scanInCartonId,
          asnUid: this.scanInAsnUid,
          recId: this.scanInAsnNo
        }
        ajax.post(api.CountScanQtyByContainerId,params).then(res=>{
          if(res.code == 200){
            this.containerIdQty = res.data

            if ( this.scanInList != null && this.scanInList.length>0){
              for (let ss = this.scanInList.length - 1; ss >= 0; ss--) {
                if (this.scanInList[ss].containerId == this.containerIdVal) {
                  let scanQty = this.scanInList[ss].scanQty;
                  this.containerIdQty += scanQty;
                }
              }
            }
          }
        })

        this.containerIdVal_b=this.containerIdVal
        this.isLocaScanIn = false;
        this.$nextTick(() => {
          if(this.systemParam.SCAN_IN_EPC!=undefined&&this.systemParam.SCAN_IN_EPC=='Y'&&!this.giftChecked){
            this.$refs.epcRef.focus()
          }else if(this.systemParam.MBSHA_SCAN_IN_EPC!=undefined&&this.systemParam.MBSHA_SCAN_IN_EPC=='Y'&&!this.mbshaScanInEpcCheck){
            this.$refs.epcRef.focus()
          } else{
            this.$refs.skuScanInRef.focus()
          }
          if(this.systemParam.SCAN_IN_EPC_BY_SKU === 'Y'){
            this.$refs.skuScanInRef.focus()
          }
        })
      }
    },
//            scan In Sku enter
    scanInSkuPressEnter(){
      this.isLocaScanIn = true;

      if (this.systemParam.SCAN_IN_SCAN_CTNID == 'Y' || this.systemParam.SCAN_IN_SCAN_CTNID == 'y' ){
        let scanInCtnidRegex =  this.systemParam.SCAN_IN_CTNID_REGEX;
        if( this.cartonIdVal != null && this.cartonIdVal.length > 0 && scanInCtnidRegex != undefined && scanInCtnidRegex != null &&  (scanInCtnidRegex.length > 0)){
          let res = this.validateStringWithRegex(this.cartonIdVal,scanInCtnidRegex);
          if (! res.success){
            this.isLocaScanIn = false;
            this.$refs.cartonIdNumRef.select()
            this.$customMessage.error(res.msg);
            return;
          }
        }
      }


      // let todsScanSkuLength = this.systemParam.SCAN_SKU_12_LETTER == undefined ? "N" : this.systemParam.SCAN_SKU_12_LETTER;
      let containerIdRequest = this.systemParam.SCAN_IN_CONTAINER_ID_REQUEST == undefined ? "N" : this.systemParam.SCAN_IN_CONTAINER_ID_REQUEST;

      if (("Y" == this.systemParam.SCAN_IN_EPC) && ("" == this.epcVal || this.epcVal.length == 0)) {

        // Tom 2024-07-15 新增勾选框【赠品】，勾选后防伪码处扫描框即为灰色，光标自动跳到SKU扫描框，可以直接扫描商品 如扫描的商品为非GWP开头的商品条码时，则弹出提示框 提示：非赠品，需扫描防伪码
        if(this.systemParam.SCAN_IN_EPC!=undefined&&this.systemParam.SCAN_IN_EPC=='Y'&&this.giftChecked==true) {
          if(!this.sacnInSkuVal.startsWith("GWP")) {
            this.isLocaScanIn = false;
            this.$refs.skuScanInRef.select()
            this.$customMessage.error(this.$t('pubGicSet.notGiftScanAntiCode'));
            return;
          }
        } else {
          // 默认流程
          this.isLocaScanIn = false;
          this.$refs.skuScanInRef.select()
          this.$customMessage.error(this.$t('pubGicSet.EPCIsEmpty'));
          return;
        }

      }

      // Tom 2024-12-11 当防伪码扫描框为可扫描状态时，未扫描防伪码直接扫描SKU时弹出提示：请扫描防伪码
      let MBSHA_SCAN_IN_EPC = this.systemParam.MBSHA_SCAN_IN_EPC;
      if(MBSHA_SCAN_IN_EPC == 'Y' && (this.orderType == 'THRK'|| this.orderType=='HHRK' ) && this.mbshaScanInEpcCheck==false && (this.epcVal==null || this.epcVal.length == 0)) {
        this.isLocaScanIn = false;
        this.$refs.skuScanInRef.select()
        this.$customMessage.error(this.$t('pubGicSet.pleaseScanAntiCode'));
        return;
      }

      if("Y" == containerIdRequest){
        if(""==this.containerIdVal || this.containerIdVal.length==0){
          this.isLocaScanIn = false;
          this.$refs.skuScanInRef.select()
          this.$customMessage.error(this.$t('pubGicSet.ContainerIdIsEmpty'));
          return;
        }
      }

      if(this.sacnInSkuVal =="Convert to Receive"){
                    this.convertToReceive();
                }else{
                  // Tom 2026-07-22 EPC is a unique per-item identifier, scan qty must be 1
                  if(this.epcVal != null && this.epcVal != '' && this.epcVal.length > 0 && this.sacnQtyVal != 1){
                    let that = this;
                    this.isLocaScanIn = false;
                    this.$customMessage.error(this.$t('pubGicSet.EpcQtyMustBeOne'), function(){
                      that.sacnQtyVal = 1;
                      this.scanInlockChecked = false;
                      that.$nextTick(() => {
                        that.$refs.skuScanInRef.focus()
                      })
                    })
                    return;
                  }

                    if(!this.scanInlockChecked){
                        this.$refs.scanInQtyNum.focus()
                        this.sacnQtyVal = ''
                        return
                    }else{

                        // Tom 2024-06-06 mkksha 特殊订单扫毛领子条码
                        let CHECK_CUS_SKU = this.systemParam.CHECK_CUS_SKU;
                        let MBSHA_SCAN_IN_EPC = this.systemParam.MBSHA_SCAN_IN_EPC;

                        if(CHECK_CUS_SKU!=undefined && CHECK_CUS_SKU!=null&& CHECK_CUS_SKU!=''&& CHECK_CUS_SKU!='N' && this.scanActionVal == 1) {
                            // 走检查是否扫毛领子条码流程（仅新增动作时） / Check whether to scan the custom SKU (collar label) barcode, add action only
                            this.checkCscSku();
                        } else if("Y" == MBSHA_SCAN_IN_EPC && this.scanActionVal == 1) {
                            // 走判断当前扫描的RFID是否为出库时扫描的RFID
                            this.checkRfidIsFromOutbound();
                        } else {
                            // 走原流程
                            this.scaninAjax();
                        }

                    }
                }

            },
//            sacnIn lock 事件
            scanlockChangeEvnt(){
                if(this.scanActionVal != 2){
                    this.scanInlockChecked = !this.scanInlockChecked
                }
            },
            scanlockSSCCChangeEvnt(){
                this.scanInlockSSCCChecked = !this.scanInlockSSCCChecked
                if(this.scanInlockSSCCChecked){
                    this.$refs.epcRef.focus();
                }else{
                    this.$refs.containerId.focus()
                }
                if(this.systemParam.SCAN_IN_EPC_BY_SKU === 'Y'){
                    this.$nextTick(()=>{
                        if(this.scanInlockSSCCChecked){
                            this.$refs.skuScanInRef.focus()
                            this.$refs.skuScanInRef.select()
                        }else{
                            this.$refs.containerId.focus();
                            this.$refs.containerId.select()
                        }
                    })
                }
            },
//            scanin 回退
            cancenlGrClick(){
                let params = {
                    grHeaderUid: this.scanInHeaderUid,
                    asnUid: this.scanInAsnUid
                }
                ajax.post(api.SCANINCANCEL, params).then(res=>{
                    if(res.code == 200){
                        this.init()
                    }
                })
            },












//            表单底部class 合集
            footerCellClassName ({ $rowIndex, column, columnIndex }) {
                return 'footerBackColor'
            },
            footerMethod({ columns, data }) {
                let that = this;
                return [
                    columns.map((column, columnIndex) => {

                        if (
                            ['asnQty', 'recQty', 'outstandingQty'].includes(
                                column.property
                            )
                        ) {
                            return that.sumPubFn(column.property);
                        }
                    })
                ];
            },
            //      页面拖拽伸缩
            toggleCollapsed() {
                this.leftshow = !this.leftshow;
                if (!this.leftshow) {
                    this.proxyDomLeft = "20px";
                    this.userLeftWidth = "20px";
                    this.userRightWidth = `calc(100% - ${this.userLeftWidth})`;
                } else {
                    setTimeout(() => {
                        this.proxyDomLeft = "50%";
                        this.userLeftWidth = this.proxyDomLeft;
                        this.userRightWidth = `calc(100% - ${this.userLeftWidth})`;
                    }, 300);
                }
            },
            dragStart(e) {
                let odiv = e.target;
                let disX = e.clientX - odiv.offsetLeft;
                let that = this;
                document.onmousemove = e => {
                    let left = e.clientX - disX;
                    let zWidth =
                        document.querySelectorAll(".userDetail")[0].offsetWidth - 40;
                    if (zWidth < left) {
                        return false;
                    }
                    if (left < 20) {
                        return false;
                    } else {
                        that.proxyDomLeft = left + "px";
                        that.userLeftWidth = that.proxyDomLeft;
                        that.userRightWidth = `calc(100% - ${that.userLeftWidth})`;
                    }
                };
                document.onmouseup = () => {
                    document.onmousemove = null;
                    document.onmouseup = null;
                };
            },

            // Tom 2024-06-05 检查是否扫描毛领子条码
            checkCscSku() {

                let params = {
                    sku : this.sacnInSkuVal,
                    relId : this.scanInAsnNo
                };

                ajax.post(api.SCANINCHECKSCSSKU, params).then(res=>{
                    if(res.code == 200){
                        let cusSku = res.data;
                        if(cusSku!=undefined&&cusSku!=null&&cusSku!='') {
                            // 有值 弹框扫描毛领子条码
                            this.$refs.refScanCusSkuWindow.show(cusSku,'SCAN_IN',this.scanInAsnNo);
                        } else {
                            // 走原流程
                            this.scaninAjax();
                        }
                    }else{
                        this.audioPubFun();
                        this.SkuExistVis = true;
                        this.errMsg = res.msg
                    }
                })


            },
            // Tom 2024-12-06 判断当前扫描的RFID是否为出库时扫描的RFID
            checkRfidIsFromOutbound() {

                let params = {
                    sku : this.sacnInSkuVal,
                    recId : this.scanInAsnNo,
                    epc : this.epcVal
                };
                let that = this;
                ajax.post(api.SCANINCHECKRFIDISFROMOUTBOUND, params).then(res=>{
                    if(res.code == 200){
                        // 走原流程
                        that.scaninAjax();
                    }else{
                        if(res.level!=undefined && res.level!=null&&res.level==1) {
                            that.$customConfirm({
                                title: that.$t('scanPack.antiCounterfeitingCodePleaseConfirm'),
                                okText: that.$t('scanPack.cancelCheckCompleteYes'),
                                cancelText: that.$t('scanPack.cancelCheckCompleteNo'),
                                onOk() {
                                    that.scaninAjax();
                                },
                                onCancel() {
                                    that.isLocaScanIn = false;
                                }
                            })
                            return;
                        }
                        this.SkuExistVis = true;
                        this.errMsg = res.msg
                        that.audioPubFun();

                    }
                })


            },
            // 确认毛领子条码回调
            confirmCusSkuCallBack(value) {
                this.missText = value;
                // 继续原流程
                this.scaninAjax();
            },
            cusSkuWindowCloseCallBack() {
                this.isLocaScanIn = false;
            },
            // Tom 2024-07-15 新增勾选框【赠品】，勾选后防伪码处扫描框即为灰色，光标自动跳到SKU扫描框，可以直接扫描商品 如扫描的商品为非GWP开头的商品条码时，则弹出提示框 提示：非赠品，需扫描防伪码
            giftCheckedChange() {
                this.epcValDisabled = this.giftChecked;
                // 选中
                if(this.giftChecked) {
                    this.$nextTick(()=>{
                        this.$refs.skuScanInRef.focus()
                    })
                } else {
                    this.$nextTick(()=>{
                        this.$refs.epcRef.focus()
                    })
                }
            },
            show() {
                let params = {
                    module_code:"SCAN_IN_F"
                }
                ajax.get(api.GENERICPRINTNODEALLBTNFORLOAD,params).then(res=>{
                    this.fieldMap = res.data.fieldMap;
                    let btnMap = res.data.behrMap;

                    if (btnMap != null ) {
                        // 遍历 Map，判断值是否为 null
                        for (let key in  btnMap) {
                            if (btnMap[key] !== null) {
                                for(let i in this.btnFunArr){
                                    if(this.btnFunArr[i].code == key){
                                        this.btnFunArr[i].arr = btnMap[key];
                                    }
                                }
                            }
                        }
                    }
                })

            },
            printByBtnConfig(btnConfig){   // 根据用户配置打印
                console.log("print---start"+btnConfig);
                if(this.scanInAsnNo == "" && this.scanInAsnNo == ""){
                    this.$customMessage.error("Rec,Carton " + this.$t('job.notNull'));
                    return;
                }
                let ajaxurl = ajax.ajaxUrl();
                this.isBtnajax = true
                let that = this
                // 构造参数
                let params = {
                    gmcUid: btnConfig.gmcUid,
                    uid: '',
                    btnName: btnConfig.name,
                    btnUid: btnConfig.uid
                }


                // 添加 订单号

                params.recId = this.scanInAsnNo
                params.cartonId = this.scanInCartonId


                // console.info(params)
                axios.post(ajaxurl + api.PRINTPREVIEW, params, {
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(function(res) {
                    let resHeader = res.headers;
                    let contentType = resHeader["content-type"];
                    let excelContentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8";
                    if(excelContentType.indexOf(contentType) !=-1) {
                        //excel
                        that.isBtnajax = false
                        var data  = res;
                        if (!data) {
                            return;
                        }
                        var blob = new Blob([data.data], {
                            type:
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                        });
                        var url = window.URL.createObjectURL(blob);
                        var aLink = document.createElement("a");
                        aLink.style.display = "none";
                        aLink.href = url;
                        aLink.setAttribute("download", "excel.xlsx");
                        document.body.appendChild(aLink);
                        aLink.click();
                        document.body.removeChild(aLink); //下载完成移除元素
                        window.URL.revokeObjectURL(url); //释放掉blob对象
                    } else {
                        //pdf
                        that.pubPdfMsgfn(res);
                    }
                });
            },
            // paf接口返回值处理
            pubPdfMsgfn(res){
                let data = res.data;
                let fileReader = new FileReader();
                let that = this
                fileReader.onload = function() {
                    try {
                        let jsonData = JSON.parse(this.result);
                        if (jsonData.code) {
                            that.$customMessage.warning(jsonData.msg);
                            that.$store.commit("updataLoading", { pbLoading: false });
                            that.isBtnajax = false
                        }
                    } catch (err) {
                        that.pubPdfUploadOk(res)
                    }
                };
                fileReader.readAsText(data)
            },
            //            pdf 成功下载方法
            pubPdfUploadOk(data){
                this.isBtnajax = false
                this.$store.commit("updataLoading", { pbLoading: false });
                let blob = new Blob([data.data], {type: "application/pdf;charset=utf-8"});
                let url = window.URL.createObjectURL(blob);
                window.open(url);
            },
            mbshaScanInEpcCheckChange() {
                this.epcValDisabled = this.mbshaScanInEpcCheck;
                // 选中
                if(this.mbshaScanInEpcCheck) {
                    this.$nextTick(()=>{
                        this.$refs.skuScanInRef.focus()
                    })
                } else {
                    this.$nextTick(()=>{
                        this.$refs.epcRef.focus()
                    })
                }
            },

        }
    }
</script>
<style lang="less">

.request-form-item::before{
  display: inline-block;
  content: '* ';
  color: #e54d42;
}

.el-message-box__content{
  color: red;
  font-size: 20px;
  text-align: center;
}
.footerBackColor{
  background: #85bff5;
  color: #fff;
    }
    #userHome {
        .userDetail {
            position: relative;
            height: 100%;
            overflow: hidden;
            background: #fff;
            .userHome-left {
                width: 50%;
                height: 100%;
                float: left;
                padding: 10px;
                position: relative;
                .isShopple {
                    position: absolute;
                    top: 0;
                    right: -32px;
                    z-index: 999;
                    background: #efefef;
                    width: 30px;
                    height: 30px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    opacity: 0.8;
                }
                .user-left-con {
                    /*overflow: hidden;*/
                }
            }
            .center-line {
                position: absolute;
                cursor: w-resize;
                left: 50%;
                height: 100%;
                border: 1px solid #efefef;
            }
            .userHome-right {
                float: right;
                width: calc(100% - 50%);
                height: 100%;
                padding: 10px;
                .user-right-con {
                    overflow: hidden;
                }
            }
        }
    }
</style>
